import reggieDisc from "../../assets/Reggie-Icon-Disc.svg";
import reggieDiscError from "../../assets/Reggie-Icon-Disc-Error.svg";

interface Props {
    isError?: boolean;
}

export const AnswerIcon = ({ isError }: Props) => {
    return (
        <img
            src={isError ? reggieDiscError : reggieDisc}
            alt="Reggie"
            aria-hidden="true"
            style={{ width: "48px", height: "48px" }} // Adjust the size as needed
        />
    );
};
